import type { DeepPartial } from '@luna/utils-ts';

import { settingsDetails } from './settings-details-config/AT';
import { savingEnvelopes } from './saving-envelopes-config/AT';
import type { SavingsConfig } from '../ProductsConfig';

export const savings: DeepPartial<SavingsConfig> = {
    statements: {
        showDownloadOptions: true,
        showHelpCenterInfoBox: true,
        showMultiDownloadCard: true,
    },
    settingsDetails,
    savingEnvelopes,
    newTransfer: {
        sideMenuLabel: 'savings.main.newWithdrawal',
    },
    layout: {
        productInfo: {
            showProductIdentifier: true,
            showBalanceAndDisposableAmounts: true,
        },
    },
};
